"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShieldIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M2.5 4.15279C2.5 3.24069 3.04611 2.42653 3.86955 2.0917C9.08897 -0.0305682 14.911 -0.030568 20.1304 2.0917C20.9539 2.42653 21.5 3.24069 21.5 4.15279V11.67C21.5 15.7831 19.377 19.5907 15.9136 21.7031L13.7976 22.9937C12.6908 23.6688 11.3092 23.6688 10.2024 22.9937L8.08641 21.7031C4.62297 19.5907 2.5 15.7831 2.5 11.67V4.15279Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M3.41589 5.53702C3.41589 4.35416 4.12408 3.29954 5.19001 2.86612C12.1291 0.0446252 19.8693 0.0446255 26.8083 2.86612C27.8742 3.29954 28.5824 4.35416 28.5824 5.53702V15.5599C28.5824 21.0154 25.7666 26.065 21.1739 28.8662L18.3526 30.5869C16.9034 31.4708 15.0949 31.4708 13.6457 30.5869L10.8245 28.8662C6.23174 26.065 3.41589 21.0154 3.41589 15.5599V5.53702Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var ShieldIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.ShieldIcon = ShieldIcon;
//# sourceMappingURL=ShieldIcon.js.map